import { WorkOrderItem } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import { Form, Input } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React from 'react';

interface Props {
  label: string;
  rows?: number;
  item?: WorkOrderItem[];
  isMechanicSheetAutoFill?: boolean;
}

const MechanicsRecordPartsServices = ({
  item,
  label,
  isMechanicSheetAutoFill = false,
  rows = 10,
}: Props) => {
  return (
    <table
      width="100%"
      cellPadding={4}
      cellSpacing={0}
      style={{ borderCollapse: 'collapse', marginTop: 12 }}
    >
      <thead>
        <tr>
          <th colSpan={3} align="left">
            {label}
          </th>
        </tr>
      </thead>

      <tbody>
        {isMechanicSheetAutoFill &&
          item &&
          item.map((_, index) => (
            <tr key={index}>
              <td style={{ width: '10%' }}>
                <Form.Item noStyle name={['items', `${index}`, 'quantity']}>
                  <Input type="number" />
                </Form.Item>
              </td>

              <td style={{ width: '60%' }}>
                <Form.Item noStyle name={['items', `${index}`, 'description']}>
                  <TextArea rows={2} />
                </Form.Item>
              </td>

              <td style={{ width: '30%' }}>
                <Form.Item noStyle>
                  <TextArea rows={1} />
                </Form.Item>
              </td>
            </tr>
          ))}

        {Array.from({ length: rows }).map((_, index) => (
          <tr key={index}>
            <td style={{ width: '10%' }}>
              <TextArea rows={1} />
            </td>
            <td style={{ width: '60%' }}>
              <TextArea rows={1} />
            </td>
            <td style={{ width: '30%' }}>
              <TextArea rows={1} />
            </td>
          </tr>
        ))}

        <tr>
          <th colSpan={2} align="right">
            Total:
          </th>

          <td>
            <TextArea rows={1} />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default MechanicsRecordPartsServices;
